module.exports = __webpack_public_path__ + "static/media/asurion-hero-mobile.04ff98a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-hero-mobile.jpg
// module id = 1383
// module chunks = 0